import * as React from "react";
const lazyLoadWithFallback = (importer) => {
  return React.lazy(async () => {
    try {
      const imported = await importer();
      if (imported && typeof imported.default === "string" && imported.default.startsWith("data:image/svg+xml") && typeof imported.ReactComponent === "function") {
        return { default: imported.ReactComponent };
      }
      return imported;
    } catch {
      return { default: (props) => /* @__PURE__ */ React.createElement("svg", { ...props }) };
    }
  });
};
export {
  lazyLoadWithFallback
};
//# sourceMappingURL=lazy-load-with-fallback.js.map
